import momentLocalTimezone from 'src/utils/momentLocalTimezone';

export default values => ({
  industry: values.industry ?? '',
  birthDate: values.birthDate
    ? momentLocalTimezone(values.birthDate)
    : momentLocalTimezone(),
  rfc: values.rfc ?? '',
  deedNumber: values.deedNumber ?? '',
  notaryName: values.notaryName ?? '',
  notaryPracticeNumber: values.notaryPracticeNumber ?? '',
  notaryPracticeCity: values.notaryPracticeCity ?? '',
  registryRegistrationNumber: values.registryRegistrationNumber ?? '',
  yearsOperating: values.yearsOperating || '',
  monthlyIncome: values.monthlyIncome || '',
  isDoctorWithTitle: values.isDoctorWithTitle || false
});
